import { useState, useEffect } from "react";
import { Avatar, Button, Box, TextField } from "@mui/material";
import { UseUser } from "./UseUser";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import AddIcon from "@mui/icons-material/Add";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditUser(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [country, setCountry] = useState();
  const { getUserByID, updateUser } = UseUser();
  const [imgState, setImgState] = useState({
    file: undefined,
    url: location.state.model.avatarName,
  });
  const { isSmall } = useBreakpoints();

  const handleChangeImage = (evt) => {
    setImgState({
      file: evt.target.files[0],
      url: URL.createObjectURL(evt.target.files[0]),
    });
  };

  const [state, setState] = useState({
    perfix: "",
    specialty: "",
    id: "",
  });

  useEffect(() => {
    if (location.state.id) {
      getUserByID(location.state.id, (User) => {
        setState({
          perfix: User[0].perfix,
          specialty: User[0].specialty,
          id: User[0].id,
        });
      });
    }
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "کاربران",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/users" },
          { name: "ویرایش کاربر", url: "/users/edituser" },
        ],
      }}
    >
      {!country ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.perfix ? state.perfix : ""}
              label="سمت کاربر "
              size="small"
              variant="outlined"
              onChange={(event) => {
                setState({ ...state, perfix: event.target.value });
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}{" "}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              id="outlined-basic"
              value={state.specialty ? state.specialty : ""}
              size="small"
              label=" عنوان کارشناس"
              variant="outlined"
              onChange={(event) => {
                setState({ ...state, specialty: event.target.value });
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}{" "}
          <Box
            component="label"
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Avatar src={imgState.url ? imgState.url : ""} alt="img" />
            <AddIcon
              sx={{
                ml: 1,
                borderWidth: 1,
                borderColor: "toositext.main",
                borderRadius: 1,
                borderStyle: "dashed",
                color: "mycolor.main",
              }}
            />
            <input
              type="file"
              id="img"
              name="avatarName"
              accept="image/*"
              multiple
              onChange={handleChangeImage}
              hidden
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}{" "}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                setProgress(true);
                updateUser(state, imgState.file, () => {
                  navigate("/users", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                });
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/users", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          <Box gridColumn="span 9"></Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
